import { getEditOrderRedirect } from '@ldt/api/order_loader/direct_upload';
import {
  checkOrderValidationErrors,
  getAvailableActions,
  getOrderMissingInfoMessages,
} from '@ldt/features/orders/components/order_actions/direct_upload_lab';
import {
  getOrderListColumns,
  orderListSearchConfig,
} from '@ldt/features/orders/order_list/direct_upload_lab';
import { getStatusFilterOptions } from '@ldt/features/orders/statuses/direct_upload_lab';
import { getDefaultWorkflowOrderStatusName } from '@ldt/features/orders/statuses/workflow_shared';
import type { LdtWorkflowDefinition } from '@ldt/workflows/types';
import { SpecimenType } from 'src/types';
import { isCustomerSuccessOrSalesUser } from 'src/utils';

export const directUploadLabWorkflow: LdtWorkflowDefinition = {
  canCreateOrder: false,
  showBillingHoldSection: false,
  showOrderingProviderSection: () => isCustomerSuccessOrSalesUser(),
  revertStatusOnSaveWithReport: true,
  orderListSearchConfig,
  supportedSpecimenTypes: new Set([
    SpecimenType.ProstateBiopsy,
    SpecimenType.MetastaticProstateBiopsy,
  ]),
  canEditOrder: (_order, _userInfoId) => false,
  getRowLink: (order, organization, location) => ({
    pathname: `/${organization}/orders/${order.id}`,
    state: {
      background: { pathname: location.pathname, search: location.search },
    },
  }),
  getStatusDisplayName: getDefaultWorkflowOrderStatusName,
  getStatusFilterOptions,
  getEditOrderRedirect,
  getAvailableActions,
  getOrderMissingInfoMessages,
  checkOrderValidationErrors,
  getOrderListColumns,
};
